import React, { useCallback, useState } from "react";
import { withStyles, useTheme } from "@material-ui/core/styles";
import { Box, Grid, Paper, IconButton, Typography } from "@material-ui/core";

import SelectionBar from "./SelectionBar";

import { color } from "d3-color";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

// import { useTranslation } from "react-i18next";

const ContentGrid = withStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    height: "100%",
  },
}))(Box);

const ContentGridMain = withStyles((theme) => ({
  root: {
    height: "100%",
    flexGrow: 1,
    position: "relative",
  },
}))(Box);

const ContentGridSideBar = withStyles((theme) => ({
  root: {
    overflow: "auto",
    background: color(theme.palette.primary.dark)
      .copy({ opacity: 0.5 })
      .formatRgb(),
    pointerEvents: "all",
    height: "100%",
    // padding: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    position: "relative",
    "& > *": {
      marginBottom: theme.spacing(1),
    },
    width: "20%",
    [theme.breakpoints.down("md")]: {
      width: "30%",
    }
  },
}))(Box);

const ContentGridSideBarContent = withStyles((theme) => ({
  root: {
    "& > *": {
      marginBottom: theme.spacing(2),
    },
  },
}))(Box);

// const RankingsTitle = withStyles((theme) => ({
//   root: {
//     textAlign: "center",
//     padding: theme.spacing(1),
//   },
// }))(Typography);

const ReferenceCointaner = withStyles((theme) => ({
  root: {
    pointerEvents: "all",
    position: "absolute",
    top: theme.spacing(2),
    left: theme.spacing(2),
  },
}))(Box);

const MapTypeSelectorContainer = withStyles((theme) => ({
  root: {
    pointerEvents: "all",
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
  },
}))(Box);

function FloatingTimelinePaper({ isExpanded, children }) {
  const theme = useTheme();
  return (
    <Paper
      style={{
        pointerEvents: "all",
        position: "absolute",
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        left: theme.spacing(2),
        height: isExpanded ? "40%" : 60,
      }}
    >
      {children}
    </Paper>
  );
}

// const useFloatingTimelineCardStyle = makeStyles((theme) => ({
//   root: {
//     pointerEvents: "all",
//     position: "absolute",
//     bottom: theme.spacing(2),
//     right: theme.spacing(2),
//     left: theme.spacing(2),
//     height: (props) => "40%",
//   },
// }));

function FloatingTimelineCard({ children }) {
  const theme = useTheme();
  // const classes = useFloatingTimelineCardStyle({ height: "10%" });

  const [expanded, setExpanded] = useState(true);

  const handleExpand = useCallback(() => {
    setExpanded(true);
  }, [setExpanded]);
  const handleContract = useCallback(() => {
    setExpanded(false);
  }, [setExpanded]);

  return (
    <FloatingTimelinePaper isExpanded={expanded}>
      {expanded ? (
        <IconButton
          onClick={handleContract}
          style={{
            pointerEvents: "all",
            position: "absolute",
            top: theme.spacing(1),
            right: theme.spacing(1),
            zIndex: 90,
          }}
        >
          <ExpandMoreIcon />
        </IconButton>
      ) : (
        <IconButton
          onClick={handleExpand}
          style={{
            pointerEvents: "all",
            position: "absolute",
            top: theme.spacing(1),
            right: theme.spacing(1),
            zIndex: 90,
          }}
        >
          <ExpandLessIcon />
        </IconButton>
      )}
      {expanded ? (
        children
      ) : (
        <Box
          style={{ cursor: "pointer" }}
          width="100%"
          height="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          onClick={handleExpand}
        >
          <Typography variant="subtitle1">Ver línea de tiempo</Typography>
        </Box>
      )}
    </FloatingTimelinePaper>
  );
}

export default function DesktopContent({
  mapTypeSelector,
  colorReference,
  country,
  selectedDate,
  onCountryChange,
  onSelectedDateChange,
  baselineDate,
  onBaselineDateChange,
  timeline,
  minDate,
  maxDate,
  topRanking,
  bottomRanking,
  period,
  onPeriodChange
}) {
  // const { t } = useTranslation();

  return (
    <ContentGrid>
      <ContentGridMain id="content-grid">
        <ReferenceCointaner>{colorReference}</ReferenceCointaner>
        <MapTypeSelectorContainer>{mapTypeSelector}</MapTypeSelectorContainer>

        <FloatingTimelineCard>{timeline}</FloatingTimelineCard>
      </ContentGridMain>
      <ContentGridSideBar id="content-side-bar">
        <ContentGridSideBarContent p={1}>
          <SelectionBar
            minDate={minDate}
            maxDate={maxDate}
            onCountryChange={onCountryChange}
            country={country}
            selectedDate={selectedDate}
            onSelectedDateChange={onSelectedDateChange}
            baselineDate={baselineDate}
            onBaselineDateChange={onBaselineDateChange}
            period={period}
            onPeriodChange={onPeriodChange}
          />
          <Paper>
            <Grid container spacing={2}>
              <Grid item sm={12}>
                {topRanking}
              </Grid>
              <Grid item sm={12}>
                {bottomRanking}
              </Grid>
            </Grid>
          </Paper>
        </ContentGridSideBarContent>
      </ContentGridSideBar>
    </ContentGrid>
  );
}
